import React from 'react';

export default () => <svg width="100px" height="100px"
    viewBox="0 0 100 100" >
    <polygon points="37.14,62.16 34.05,87.5 80.8,44.47 54.69,45.42 72.88,16.53 33.78,16.53 19.2,63.12 "/>
</svg>